import React from "react";

interface TableSkeletonProps {
  columns: string[]; // Array of column labels
  rows?: number;
  mainClass?: string;
  subClassName?: string;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  rows = 6,
  mainClass = "rounded-r-3xl",
  subClassName = "bg-[#FCFDF8]",
}) => {
  return (
    <div className={`bg-[#F7F6F2] pt-2 ${mainClass} rounded-3xl`}>
      <div
        className={`overflow-auto ${subClassName} rounded-tl-none rounded-3xl `}
      >
        <table className="w-full text-sm border border-dashed border-gray-300 whitespace-nowrap">
          <thead className="text-[#212121]/90 uppercase tracking-wider border-b border-t border-dashed border-gray-300 sticky top-0 z-20 shadow-sm bg-[#E0E0E0]">
            <tr>
              {columns?.map((label, idx) => (
                <th
                  key={idx}
                  className="text-left font-bold text-xs uppercase tracking-wider px-4 py-1.5 border-r last:border-none border-dashed border-gray-300 select-none"
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-300 divide-dashed">
            {Array.from({ length: rows }).map((_, rowIdx) => (
              <tr key={rowIdx} className="animate-pulse group cursor-default">
                {columns?.map((_, colIdx) => (
                  <td
                    key={colIdx}
                    className="px-4 py-3 border-r last:border-none border-dashed border-gray-300"
                  >
                    <div className="h-4 w-full bg-gray-200 rounded" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableSkeleton;
